@if (loading) {
  <div class="hc-loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>
}

@if (error) {
  <p class="hc-error">Sorry, we couldn't load the help center right now. Please try again later.</p>
}

@if (!loading && !error && collections.length === 0) {
  <p class="hc-empty">No articles are available yet.</p>
}

@if (!loading && collections.length > 0) {
  <div class="hc-card-grid">
    @for (card of collections; track card.collection) {
      <button type="button" class="hc-card" (click)="openCollection.emit(card.collection)">
        <span class="hc-card-icon"><mat-icon>{{ card.icon }}</mat-icon></span>
        <span class="hc-card-text">
          <span class="hc-card-title">{{ card.collection }}</span>
          <span class="hc-card-meta">{{ card.count }} {{ card.count === 1 ? 'article' : 'articles' }}</span>
        </span>
      </button>
    }
  </div>
}
